import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
export default {
  __name: 'index',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50]
    },
    layout: {
      type: String,
      default: "total, prev, pager, next "
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:page", "update:limit", "pagination"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const currentPage = computed({
      get: () => props.page,
      set: val => emit("update:page", val)
    });
    const pageSize = computed({
      get: () => props.limit,
      set: val => emit("update:limit", val)
    });
    const handleSizeChange = val => {
      emit("pagination", {
        page: currentPage.value,
        limit: val
      });
    };
    const handleCurrentChange = val => {
      emit("pagination", {
        page: val,
        limit: pageSize.value
      });
    };
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([{
          hidden: __props.hidden
        }, "pagination-container"])
      }, [_createVNode(_component_el_pagination, _mergeProps({
        background: __props.background,
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        layout: __props.layout,
        "page-sizes": __props.pageSizes,
        total: __props.total
      }, _ctx.$attrs, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }), null, 16, ["background", "current-page", "page-size", "layout", "page-sizes", "total"])], 2);
    };
  }
};